<button mat-button class="environment-button" [ngClass]="currentClass"
        *ngxPermissionsOnly="['stagingPermission', 'torchAdmin', 'torchGlobalAdmin']"
        (click)="changeEnvironment()" [matTooltip]="tooltipText">
  View in <br>
  <b>{{otherEnvironment}}</b>
</button>
